const styles = {
  destination: {
    marginBottom: "48px",
  },
  destinationHeading: {
    margin: "16px auto",
  },
};

export default styles;
